import { render, staticRenderFns } from "./employee-following.vue?vue&type=template&id=fdeaf638&scoped=true&"
import script from "./employee-following.vue?vue&type=script&lang=js&"
export * from "./employee-following.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdeaf638",
  null
  
)

export default component.exports